import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { ECollection } from "../enums/ECollection";
import { environment } from '../../environments/environment';
import { IQueryFormat } from '../enums/types';

@Injectable({ providedIn: 'root' })
export class PincodeService extends BaseService {
    constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService,
                public authService: AuthService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.COMMON_DB}/${ECollection.PINCODES}`);
    }

    async queryPublic<T>(body: IQueryFormat) {
        const resp = <any>await firstValueFrom(this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + `${this.modelPath}/query`, body));
        return resp.data;
    }
}

